import React from "react";
import * as aor from "react-admin";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";
import TranslatedText from "./TranslatedText";
import Create from "@material-ui/icons/Create";
import myRestClient from "../common/restClient";
import tccStyles from "../common/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { POLICY_INSTALLATIONS } from "../common/rolesManagement";
import { InstallationEventStatus } from "../common/statuses";
import TextField from "@material-ui/core/TextField";
import { getConfig } from "../common/utilities";
import { OperationType } from "../common/operationTypes";
import InputAdornment from "@material-ui/core/InputAdornment";
import HelpIcon from "@material-ui/icons/Help";

class AccessUrlTransfer extends React.Component {
    state = {
        open: false,
        url_name: null,
        loading: false,
        operation: [],
        is_operational: null,
        has_operation_running: null,
        installationStatus: null,
        installationLocked: false,
        typeInstallationLocked: false
    };
    componentDidMount = () => {
        this.setState({
            url_name: this.props.record.access_url,
            customer_id: this.props.record.customer_id,
            installationStatus: this.props.record.status,
            installationLocked: this.props.record.locked,
            typeInstallationLocked: this.props.record.installation_type_locked
        });

        getConfig().then(result => {
            if (result) {
                this.setState({ portal_locked: result.portal_lock });
            }
        });

        if (this.props.record.installation_type_id) {
            const params = {
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "name", order: "asc" },
                filter: {
                    installation_type_id: this.props.record.installation_type_id
                },
                filter_type: [OperationType.UrlTransfer]
            };
            myRestClient("GET_LIST", "operations", params).then(
                result => {
                    const data = result.data.map(item => {
                        return {
                            id: item.operation_type_name,
                            name: item.operation_type_description
                        };
                    });
                    this.setState({
                        operation: data
                    });
                },
                error => {
                    return error;
                }
            );
        }
        const params = {
            filter: { export: true },
            pagination: { page: 1, perPage: 1000 },
            sort: { field: "customer_id", order: "asc" },
            id_inst: [this.props.record.id],
            infoTransfer: true
        };
        myRestClient("GET_LIST", "installations", params).then(
            result => {
                this.setState({
                    is_operational: result.data[0].is_operational,
                    has_operation_running: result.data[0].has_operation_running
                });
            },
            error => {
                return error;
            }
        );
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false, url_name: this.props.record.access_url });
    };

    handleOk = () => {
        const query = {
            id: this.props.record.id,
            data: { tmp_access_url: this.state.url_name }
        };
        this.setState({
            loading: true
        });
        myRestClient("UPDATE_NO_PREV", "installations", query).then(
            result => {
                this.setState({
                    open: false,
                    showSnackBar: true,
                    message: "Inviata richiesta aggiornamento",
                    error: false,
                    url_name: null,
                    loading: false
                });
            },
            error => {
                this.setState({
                    error: true,
                    showSnackBar: true,
                    message: error.message,
                    loading: false
                });
            }
        );
    };

    onUrlChanged = value => {
        this.setState({ url_name: value });
    };

    myUrlSelect(props) {
        return (
            <TextField
                value={this.state.url_name}
                label="Access url"
                name="access_url"
                type="text"
                margin="normal"
                autoComplete="off"
                disabled={false}
                onChange={value => {
                    this.onUrlChanged(value.currentTarget.value);
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Tooltip
                                placement="left"
                                title={
                                    <TranslatedText
                                        resource_name={`resources.installation_types.url_pattern.${this.props.record.installation_type}`}
                                    />
                                }
                            >
                                <HelpIcon
                                    style={{
                                        verticalAlign: "center",
                                        marginLeft: 20,
                                        marginBottom: 3
                                    }}
                                />
                            </Tooltip>
                        </InputAdornment>
                    )
                }}
            />
        );
    }

    MyAccessUrlField(props) {
        return props.record && props.record.complete_installation_url ? (
            <aor.Labeled label="resources.installations.fields.complete_installation_url">
                <aor.UrlField
                    target="_blank"
                    source="complete_installation_url"
                    record={props.record}
                />
            </aor.Labeled>
        ) : (
            <aor.Labeled label="resources.installations.fields.access_url">
                <aor.TextField
                    source="access_url"
                    record={props.record}
                    {...props}
                />
            </aor.Labeled>
        );
    }

    renderErrorMessage() {
        return this.state.error === true ? (
            <div>
                <span style={{ color: tccStyles.colors.error }}>
                    {this.state.message === "Validation failed" ? (
                        "Errore nella validazione dei parametri inseriti"
                    ) : this.state.message.includes(
                          "PATCH installations - AWX start lambda for Update failed installation_id"
                      ) ? (
                        "Errore comunicazione con il cloud"
                    ) : (
                        <TranslatedText resource_name={this.state.message} />
                    )}
                </span>
            </div>
        ) : (
            <div />
        );
    }

    render() {
        const permissions = this.props.permissions;
        return (
            <aor.FormDataConsumer>
                {({ formData }) => {
                    return formData ? (
                        <React.Fragment>
                            {this.MyAccessUrlField(this.props)}
                            {permissions &&
                                permissions.includes(
                                    POLICY_INSTALLATIONS.TRANSFER
                                ) &&
                                this.state.is_operational &&
                                !this.state.has_operation_running &&
                                this.state.operation.length > 0 &&
                                this.state.installationStatus !==
                                    InstallationEventStatus.pendingDelete &&
                                ((!this.state.installationLocked &&
                                    !this.state.portal_locked &&
                                    !this.state.typeInstallationLocked) ||
                                    this.props.isAdminRole) && (
                                    <Button
                                        style={{
                                            position: "relative",
                                            top: 24
                                        }}
                                        color="primary"
                                        target="_blank"
                                        onClick={this.handleClickOpen}
                                    >
                                        <Tooltip
                                            title={
                                                <TranslatedText
                                                    resource_name={`resources.installations.actions.url_transfer`}
                                                />
                                            }
                                        >
                                            <Create />
                                        </Tooltip>
                                    </Button>
                                )}
                            <Dialog
                                style={{
                                    overflow: "visible",
                                    overflowY: "visible"
                                }}
                                disableBackdropClick
                                disableEscapeKeyDown
                                maxWidth="xs"
                                open={this.state.open}
                            >
                                <DialogTitle id="form-dialog-title">
                                    <b>
                                        <TranslatedText
                                            resource_name={`resources.installations.actions.url_transfer`}
                                        />
                                    </b>
                                </DialogTitle>
                                <DialogContent
                                    style={{
                                        overflow: "visible",
                                        overflowY: "visible"
                                    }}
                                >
                                    {this.myUrlSelect(this.props)}
                                    {this.renderErrorMessage()}
                                </DialogContent>
                                <DialogActions>
                                    <div
                                        align="center"
                                        style={{
                                            visibility: this.state.loading
                                                ? "visible"
                                                : "hidden"
                                        }}
                                    >
                                        {<CircularProgress />}
                                    </div>
                                    {!this.state.loading && (
                                        <b>
                                            <Button
                                                onClick={this.handleClose}
                                                color="primary"
                                            >
                                                <TranslatedText
                                                    resource_name={
                                                        "ra.actions.cancel"
                                                    }
                                                />
                                            </Button>
                                            <Button
                                                onClick={this.handleOk}
                                                color="primary"
                                            >
                                                <TranslatedText
                                                    resource_name={
                                                        "ra.actions.ok"
                                                    }
                                                />
                                            </Button>
                                        </b>
                                    )}
                                </DialogActions>
                            </Dialog>
                        </React.Fragment>
                    ) : null;
                }}
            </aor.FormDataConsumer>
        );
    }
}

export default AccessUrlTransfer;



// WEBPACK FOOTER //
// ./src/components/AccessUrlTransfer.js